import './Contact.css';

const Contact = () => {
  return (
    <div className='main-contact-page py-5'>
        <div className="container">
          <h2 className="fs-2 head-font-bold text-center text-brand-secondary text-uppercase mb-5">Contact Us</h2>
          <div className="row">
            <div className="contact-col col-md-9 pe-5 mb-5">
              <p className="mb-0 fs-4 body-font-bold lh-sm">Drop us a Feedback.</p>
              <p className="mb-4 fs-sm body-font-light text-muted">We'll get in touch as soon as possible.</p>
              <div className="d-flex">
                <input type="text" className="form-control border shadow-none outline-none rounded-3 mb-3 me-2" placeholder='Your name'/>
                <input type="text" className="form-control border shadow-none outline-none rounded-3 mb-3" placeholder='Your email'/>
              </div>
              <textarea className='form-control rounded-3 shadow-none outline-none border' placeholder='Your message'></textarea>
              <button className="btn btn-brand-secondary px-4 rounded-3 mt-3">Send message</button>
            </div>
            <div className="col-md-3 mb-5">
              <p className="mb-2 fs-4 body-font-bold lh-sm">Other options</p>
              <a href="https://maps.app.goo.gl/FcBjcKZi6T9Y8wMj7" className="nav-link body-font-light mb-2">Sai Plush Apartment, Kon, Kalyan, Kongaon, Maharashtra 421311.</a>
              <a href="mailto:pentadeco@gmail.com" className="nav-link body-font-light mb-2">pentadeco@gmail.com</a>
              <a href="tel:+917738494171" className="nav-link body-font-light">+91 77384 94171</a>
              <a href="tel:+918433551012" className="nav-link body-font-light">+91 84335 51012</a>
              <a href="tel:+919273158535" className="nav-link body-font-light">+91 92731 58535</a>
            </div>
          </div>

        </div>
        <div className="map-wrapper">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3928.6732548541404!2d73.1123242!3d19.2467707!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be797339660dae3%3A0x9b0ccec382d87ae!2sPENTADECO%20-%20Home%20%26%20Kitchen%20Decor!5e1!3m2!1sen!2sin!4v1757854264980!5m2!1sen!2sin" width="100%" height="450" style={{border: '0px'}} title='google maps' referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
    </div>
  )
}

export default Contact